'use client';

import Link from 'next/link';

export default function NotFound() {
	return (
		<div className="flex flex-col items-center justify-center text-center px-4 min-h-screen">
			<h1 className="text-3xl font-bold text-red-600">404 - Page Not Found</h1>
			<p className="mt-2 text-gray-600">The page you are looking for does not exist or has been moved.</p>
			<Link
				href="/"
				className="mt-4 inline-block px-6 py-2 bg-blue-700 text-white rounded hover:bg-blue-800"
			>
				Go to Homepage
			</Link>
		</div>
	);
}
